import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PlayerFastForwardIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PlayerFastForward",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m29.31 14.46-11.64-9.3a1.24 1.24 0 0 0-1.47-.07c-.45.37-.74.92-.74 1.55v7.5L4.22 5.16a1.24 1.24 0 0 0-1.47-.07c-.46.37-.74.93-.74 1.55v18.68c0 .63.28 1.19.73 1.57.2.14.45.22.71.22h.04c.28 0 .54-.11.73-.3l11.25-8.95v7.45c0 .63.28 1.19.73 1.57.2.14.44.22.71.22h.04c.28 0 .54-.11.73-.3l11.63-9.21c.42-.37.68-.91.68-1.51v-.16c0-.59-.27-1.12-.68-1.47Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m17 26.57 10.29-10.28L17 6z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17 27.71c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V6c0-.46.28-.88.71-1.06s.92-.08 1.25.25L28.1 15.48a1.16 1.16 0 0 1 0 1.62L17.81 27.39c-.22.22-.51.33-.81.33Zm1.14-18.95v15.05l7.53-7.53-7.53-7.53ZM5 26.57l10.29-10.28L5 6z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5 27.71c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V6c0-.46.28-.88.71-1.06s.92-.08 1.25.25L16.1 15.48a1.16 1.16 0 0 1 0 1.62L5.81 27.39c-.22.22-.51.33-.81.33ZM6.14 8.76v15.05l7.53-7.53-7.53-7.53Z"
      })]
    })
  }));
};
PlayerFastForwardIcon.displayName = 'PlayerFastForwardIcon';